import * as React from 'react';
import { Trans } from 'react-i18next';
import { IconButton, Popover } from '@mui/material';
import { styled } from '@mui/material/styles';
import { AspectRatio } from "@mui/icons-material"

export type Props = {
	moduleId?: string
	onClick?: () => void
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

const StyledButton = styled(IconButton)`
    color: #151744;
`;

export default function ModuleFitToTile(props: Props) {
	const [popoverOpened, setPopoverOpened] = React.useState(false)
	const buttonRef = React.useRef<Element>(null)
    const stopPropagation = (e:React.MouseEvent) => e.stopPropagation();

	return <>
		<StyledButton ref={buttonRef} onMouseDown={stopPropagation} onClick={props.onClick} onMouseEnter={() => setPopoverOpened(true)} onMouseLeave={() => setPopoverOpened(false)}>
			<AspectRatio />
		</StyledButton>
		<Popover
			className="custom-popover"
			sx={{pointerEvents: 'none'}}
			open={popoverOpened}
			anchorEl={buttonRef.current}
			anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
			transformOrigin={{vertical: 'top', horizontal: 'left'}}
			disableRestoreFocus
		>
			<h4><T>Fit image to tile</T></h4>
            <p><T>Your image will fit into your tile without changing your tile size.</T></p>
		</Popover>
	</>
}
